import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import SecuredReducer from "../../lib/keycloak/slice.ts";
import AuthReducer from "../../pages/auth/slice.ts";
import BankReducer from "../../pages/company/bankAccount/slice.ts";
import ChatReducer from "../../pages/company/chat/slice.ts";
import DocumentReducer from "../../pages/company/documents/slice.ts";
import EventsReducer from "../../pages/company/events/slice.ts";
import ReferrersReducer from "../../pages/company/referrers/slice.ts";
import CompanyReducer from "../../pages/company/slice.ts";
import DashboardReducer from "../../pages/dashboard/slice.ts";
import AppointmentsReducer from "../../pages/financialAdvisor/appointments/slice.ts";
import CollaboratorReducer from "../../pages/financialAdvisor/collaborator/slice.ts";
import SpontaneousFinancialAdvisorReducer from "../../pages/financialAdvisor/signup/slice.ts";
import FinancialAdvisorReducer from "../../pages/financialAdvisor/slice.ts";
import NoticeReducer from "../../pages/notice/slice.ts";
import OperatorReducer from "../../pages/operator/slice.ts";
import LayoutReducer from "../../ui/layout/slice.ts";
import ObjectReducer from "../object/slice.ts";
import BrightyReducer from '../../pages/company/chat/brighty/slice.ts'

export const store = configureStore({
    reducer: {
        secured: SecuredReducer,
        financialAdvisor: FinancialAdvisorReducer,
        spontaneous: SpontaneousFinancialAdvisorReducer,
        operator: OperatorReducer,
        company: CompanyReducer,
        collaborator: CollaboratorReducer,
        layout: LayoutReducer,
        referrers: ReferrersReducer,
        events: EventsReducer,
        auth: AuthReducer,
        object: ObjectReducer,
        document: DocumentReducer,
        notice: NoticeReducer,
        dashboard: DashboardReducer,
        chat: ChatReducer,
        bank: BankReducer,
        appointments: AppointmentsReducer,
        brighty: BrightyReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;

